module.exports = __webpack_public_path__ + "img/giftcard-logo.fc9aa3df.png";